module.exports = __webpack_public_path__ + "static/prestashop_bizum-5bc7c2b2bbb4a0ed3c089cf12d8e485e.svg";